import { useMemo } from 'react';
import { useLoggedUser } from '~/services/user';
import { useUserBankAccountList } from '~/services/user-bank-account';
import { ConsentStatus } from '~/types/consent';
import { InstitutionSource } from '~/types/institution';
import { UserBankAccountStatus, UserBankAccountBindingError } from '~/types/user-bank-account';
import { useVisibleSwanConsent } from './useVisibleSwanConsent';

const FIXABLE_BY_INVITEE_ERRORS = [
  UserBankAccountBindingError.EMAIL_VERIFIED_MATCH_ERROR,
  UserBankAccountBindingError.ID_VERIFIED_MATCH_ERROR,
];

export const useUserBankAccountOnboarding = () => {
  const { data: user } = useLoggedUser();
  const swanConsent = useVisibleSwanConsent();
  const isAccountHolder = swanConsent?.status === ConsentStatus.Authorized && swanConsent.user?.id === user?.id;

  const userBankAccountQuery = useUserBankAccountList({
    filters: {
      source: InstitutionSource.SWAN,
      statuses: [UserBankAccountStatus.INVITATION_SENT, UserBankAccountStatus.BINDING_USER_ERROR],
      userId: user?.id,
    },
    enabled: !!user,
  });

  const userBankAccount = userBankAccountQuery.data?.[0];
  const bindingErrors: UserBankAccountBindingError[] = useMemo(
    () => userBankAccount?.bindingErrors || [],
    [userBankAccount],
  );
  const isInviterActionRequired =
    bindingErrors.length > 0 && !bindingErrors.some((error) => FIXABLE_BY_INVITEE_ERRORS.includes(error));

  return {
    userBankAccount,
    canStartOnboarding: !!userBankAccount && !isInviterActionRequired && !isAccountHolder,
    isLoading: userBankAccountQuery.isLoading,
  };
};
